import { useWindowWidth } from '@react-hook/window-size'
import {
  Anchor,
  Button,
  Div,
  DropDownMenu,
  Flex,
  Icon,
  LinkColumnType,
} from '@sendoutcards/quantum-design-ui'
import React, { useState } from 'react'
import { SponsorFragment } from 'src/graphql'

type AccountSectionProps = {
  getSponsorSuffix: (sponsor: SponsorFragment | undefined) => string
  sponsor?: SponsorFragment
}

const AccountSection = (props: AccountSectionProps) => {
  const { getSponsorSuffix, sponsor } = props
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const width = useWindowWidth()
  const isMobile = width < 600

  type AccountSectionLinks = {
    login: string
    join: string
  }

  const accountSectionLinks: AccountSectionLinks = {
    login:
      'https://app.sendoutcards.com/dashboard/account?client=soc&redirect_uri=https%3A%2F%2Fapp.sendoutcards.com%2Fcatalog',
    join: `https://app.sendoutcards.com/dashboard/account?client=soc&join&redirect_uri=https%3A%2F%2Fapp.sendoutcards.com%2Fcatalog${
      sponsor ? `&sponsor=${getSponsorSuffix(sponsor)}` : ''
    }`,
  }

  const mobileDropdownLinks: LinkColumnType = {
    title: 'My Account',
    links: [
      { title: 'Login', href: accountSectionLinks.login },
      { title: 'Join Now', href: accountSectionLinks.join },
    ],
  }

  return isMobile ? (
    <Flex position="relative">
      <Icon name="user" size="xSmall" primaryColor="primaryBodyText" />
      <Icon
        name={'chevron'}
        orientation={isDropdownOpen ? 'up' : 'down'}
        size={'small'}
        onClick={() => {
          setIsDropdownOpen(!isDropdownOpen)
        }}
        primaryColor={'primaryBodyText'}
      />
      <DropDownMenu
        right={-24}
        top={48}
        isOpen={isDropdownOpen}
        linkColumn={mobileDropdownLinks}
      />
    </Flex>
  ) : (
    <Div width="200px">
      <Flex columnGap="x2">
        <Anchor
          href={accountSectionLinks.login}
          style={{ textDecoration: 'none' }}
        >
          <Button size="xSmall" type="shadow" hover={true}>
            Login
          </Button>
        </Anchor>
        <Anchor
          href={accountSectionLinks.join}
          style={{ textDecoration: 'none' }}
        >
          <Button hover={true} outlined={true} size="xSmall">
            Join Now
          </Button>
        </Anchor>
      </Flex>
    </Div>
  )
}

export default AccountSection
